/* istanbul ignore file */
import React from 'react';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { BreadcrumbsProps } from 'framework/ui/BreadCrumbs';
import SingleProjectBreadcrumbs from 'domain/projects/project/shared/SingleProjectBreadcrumbs';

const StatusesBreadcrumbs = ({ children }: BreadcrumbsProps) => {
  return (
    <SingleProjectBreadcrumbs>
      <SingleBreadcrumbItem entity="Status" />
      {children}
    </SingleProjectBreadcrumbs>
  );
};

export default StatusesBreadcrumbs;
